import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
			fullWidth
			maxWidth="xs"
		>
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>
			<DialogContent dividers>
				<Typography>{children}</Typography>
			</DialogContent>
			<DialogActions>
				<BotaoCancelar onClick={() => onClose(false)}>
					{i18n.t("confirmationModal.buttons.cancel")}
				</BotaoCancelar>
				<BotaoConfirmar
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</BotaoConfirmar>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
